import React from 'react'
import { Heading, Spinner, Text } from '@plurall/elo-beta'

import styles from './LoadingContainer.module.scss'

interface ILoadingContainerProps {
  description: string
  text: string
  fullscreen: boolean
  size: 'small' | 'large'
}

const LoadingContainer = ({
  description,
  text,
  fullscreen,
  size = 'large',
}: ILoadingContainerProps) => (
  <div className={fullscreen ? styles.fullscreen : styles.loading} data-test-id='loading'>
    <Spinner size={size} dataTestId='loading-plurall-loading' />
    {text && (
      <div className={styles.text}>
        <Heading variant='brand' element='h3'>
          {text}
        </Heading>

        {description && (
          <div className={styles.description}>
            <Text size='t3'>{description}</Text>
          </div>
        )}
      </div>
    )}
  </div>
)

export default LoadingContainer
